// frontend/admin-portal/src/components/settings/SettingsHeader.jsx
import React from "react";
import { Button } from "@fiberhome/shared-ui";

export default function SettingsHeader({ saving, dirty, onSave, onReset }) {
  return (
    <div className="fh-settings-header">
      <div className="fh-settings-header__actions">
        {dirty && (
          <Button variant="ghost" onClick={onReset} disabled={saving}>
            Reset
          </Button>
        )}
        <Button
          variant="primary"
          onClick={onSave}
          loading={saving}
          disabled={!dirty}
        >
          Save Changes
        </Button>
      </div>
    </div>
  );
}
